import React from 'react';
import PropTypes from 'prop-types';

import DefaultLayout from './default-layout';
import ShelfAppBar from '../packages/appbar/shelf';
import SetHostLocale from '../components/set-host-locale';

import { ScrollContextProvider } from '../components/scroll/scroll-context';

const StartLayout = ({ children, title, shelfSelectButton = true }) => {
  return (
    <DefaultLayout title={title} data-testid="layout-start">
      <SetHostLocale />
      <ScrollContextProvider timeout={150}>
        <ShelfAppBar shelfSelectButton={shelfSelectButton} />
        {children}
      </ScrollContextProvider>
    </DefaultLayout>
  );
};

StartLayout.propTypes = {
  children: PropTypes.node.isRequired,
  shelfSelectButton: PropTypes.bool,
  title: PropTypes.string,
};

export default StartLayout;
